/**
 * Template for displaying the Welcome Guide
 * @package Custom Welcome Guide
 * @since 1.0.0
 * @since wp 5.5
 * @see https://github.com/WordPress/gutenberg/tree/trunk/packages/components/src/guide
 *
 */

import { Guide } from '@wordpress/components';

const SiteGuide = ( props ) => {
	const guides = pixcareSiteGuides.guides;
	const { siteGuideId } = props;

	return (
		typeof guides[siteGuideId] !== 'undefined' &&
		<>
			{!!guides[siteGuideId].custom_css && <style>{guides[siteGuideId].custom_css}</style>}
			<Guide {...props}
				   className={ "edit-post-site-guide site-guide " + guides[siteGuideId]?.container_classes.join(' ') }
				   pages={guides[siteGuideId].pages.map( ( page, index ) => (
					   {
						   image: page.image ? <div className="site-guide-image"><img src={page.image} alt={ "Site guide #"+index+"page image"} /></div> : '',
						   content: (
							   <div
								   className="site-guide-content"
								   dangerouslySetInnerHTML={{ __html: page.content }}/>
						   )
					   }
				   ) )
				   }
				   contentLabel={guides[siteGuideId].label}
				   finishButtonText={guides[siteGuideId].finish_button_label}
			/>
		</>
	);
};

export default SiteGuide;
